module.exports = __webpack_public_path__ + "img/hoymiles.797e4550.svg";